import { useLocation, useNavigate } from 'react-router-dom';
import { AppSearchTabs } from '../../components/enhancedSearch/AppSearchPage/AppSearchTabs';
import AppSearchBar from '../../components/enhancedSearch/AppSearchPage/AppSearchBar';
import style from './appModePage.module.scss';
import { useEffect, useState } from 'react';

const SearchLandingPage = (props) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(search);
    if (params.has("search")) {
      setSearchValue(params.get("search"));
    }
  }, [search]);

  return (
    <div className={style.searchContainer}>
      <AppSearchBar
        push={navigate}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      ></AppSearchBar>
      <AppSearchTabs push={navigate} searchValue={searchValue} />
    </div>
  );
};

export default SearchLandingPage;